import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-movie-2-fill text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-xl font-bold text-foreground-950">
                天狼影院
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              天狼影院致力于为用户提供高清免费在线观影体验，即点即播不缓冲，流畅追剧看电影。汇聚最新电影、电视剧、综艺、动漫、纪录片，海量高清视频资源，随时随地畅享视听盛宴。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="抖音">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-950 mb-4">
              视频分类
            </h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-950 mb-4">
              快速链接
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">关于我们</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">帮助中心</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">用户协议</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">隐私政策</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-950 mb-4">
              联系我们
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-foreground-500 text-sm"></i>
                </div>
                <span className="text-sm text-foreground-600">contact@tianlangcinema.com</span>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-foreground-500 text-sm"></i>
                </div>
                <span className="text-sm text-foreground-600">400-888-6666</span>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-foreground-500 text-sm"></i>
                </div>
                <span className="text-sm text-foreground-600">北京市朝阳区望京科技园A座</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 天狼影院 版权所有 | 京ICP备2024000000号-1
          </p>
          <p className="text-xs text-foreground-500">
            天狼影院 - 高清免费在线观看，即点即播不缓冲
          </p>
        </div>
      </div>
    </footer>
  );
}